module.exports = __webpack_public_path__ + "static/rex-knight-46a06d4cb2cfd9cf4c2d4f84895f5835.png";